<template>
  <teacherTemplate>
    <div class="size margin container align-items-stretch wrap justify-content-center relative">
      <div class="col-12 col-xl-9 col-lg-9 col-md-8 col-sm-12 container column">
        <div class="box-content--header container align-items-center justify-content-center hidden">
          <div class="box-content--header__img">
            <div class="img1 container align-items-center justify-content-center animation-bottom">
              <div class="img2 container align-items-center justify-content-center">
                <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
              </div>
            </div>
          </div>
          <div class="box-content--header__text flex-grow-1 flex-basis-400">
            <h2 class="animation-top animation-delay-02">PERSONAL <span>TEACHER</span></h2>
            <hr class="header-text-hr animation-top animation-delay-02">
            <p class="animation-bottom animation-delay-04">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          </div>
        </div>
        <div class="box-content shadow-box box-content-border hidden">

          <div class="container box--item animation-bottom animation-delay-05">
            <div class="classrooms">
              <div class="classrooms__header">
                <h3 class="classrooms__header__heading">Classrooms</h3>
              </div>
              <div class="classrooms__header">
                <span class="classrooms__header__heading classrooms__header__heading--online">online</span>
              </div>
              <div class="classrooms__box container justify-content-center align-items-center" v-if="!classrooms.length">
                <h4 style="padding: 0px 10px;">No classroom</h4>
              </div>
              <div class="classrooms__box" v-else>
                <div class="classrooms__box__item" v-for="(classroom, index) in classrooms">
                  <p><h5>Classroom {{ index + 1 }}</h5></p>
                  <p>Status: <b>{{ classroom.active ? 'ACTIVE' : 'EXPIRED' }}</b></p>
                  <p v-if="classroom.teacher">Used by: {{ classroom.teacher }}</p>
                  <button
                    class="open-classroom btn btn-sm btn-green"
                    :disabled="(classroom.teacher_id != teacher._id && (classroom.busy || !classroom.active)) || creating"
                    @click="getStream(classroom._id, !!classroom.teacher_id, classroom.classroom_key)"
                  >
                    {{ (classroom.teacher_id == teacher._id) ? 'Join' : 'Open' }} Classroom
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-call modal-call__animation--open" ref="modal" v-if="show">
      <div class="modal-call__talking">
        <span class="modal-call__talking__classroomkey">{{ classroomKey }}</span>
        <div class="container wrap modal-call__talking__box">
          <div class="modal-call__talking__streams">
            <div class="modal-call__talking__streams__mine">
              <video ref="teacher_video" class="modal-call__talking__streams__mine__teacher" autoplay muted/>
            </div>
            <div class="modal-call__talking__streams__others">
              <student-video-chat
                v-for="student in students"
                :key="student._id"
                :student="student"
                :ref="`student_video_${student._id}`"
                :canMute="true"
                :setMuted="setMuted"
              />
            </div>
          </div>
          <chat-box
            :chat="chat"
            :person="teacher._id"
            :sendMessage="sendMessage"
            :hasStream="false"
          />
        </div>
        <div class="modal-call__talking__hangup">
          <div class="modal-call__talking__hangup__icon" @click="closeClassroom()">
            <font-awesome-icon icon="phone-slash"/>
          </div>
        </div>
      </div>
      <audio ref="alert-beep" style="display: none;" src="@/assets/media/notification.mp3"></audio>
    </div>
  </teacherTemplate>
</template>

<script type="text/javascript">
  import teacherTemplate from '@/components/template/teacher'
  import StudentVideoChat from '@/components/StudentVideoChat'
  import ChatBox from '@/components/ChatBox'

  import io from 'socket.io-client'

  const PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
  const SessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitSessionDescription

  export default {
    data () {
      return {
        classroomKey: null,
        currentRoom: null,
        stream: null,
        socket: null,
        socketKeepAlive: null,
        connectionTimeout: null,
        show: false,
        creating: false,
        students: [],
        chat: [],
        messageText: ''
      }
    },
    computed: {
      teacher () {
        return this.$store.getters['teacher/get']
      },
      classrooms () {
        return this.$store.getters['teacher/classrooms']
      }
    },
    components: {
      [StudentVideoChat.name]: StudentVideoChat,
      [ChatBox.name]: ChatBox,
      teacherTemplate
    },
    methods: {
      async getStream (classroom_id, reconnect, classroom_key) {
        try {
          this.show = true
          this.creating = true

          this.stream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: {
                min: 320,
                ideal: 1280,
                max: 1920
              },
              height: {
                min: 240,
                ideal: 720,
                max: 1080
              },
              frameRate: 30, // Shorthand for ideal.
              facingMode: 'environment'
            },
            audio: {
              mandatory: {
                googEchoCancellation: "false",
                googAutoGainControl: "false",
                googNoiseSuppression: "false",
                googHighpassFilter: "false"
              },
              optional: []
            }
          })

          if (!this.stream || (this.stream && !this.stream.active))
            throw { message: 'Failed to get video' }

          this.$refs['teacher_video'].srcObject = this.stream

          this.currentRoom = classroom_id

          if (reconnect)
            this.classroomKey = classroom_key

          await this.createConnection(reconnect)
        } catch (error) {
          this.creating = false
          alert(error.message || 'Failed to Create Room')
          this.closeClassroom()
        }
      },
      createConnection (reconnect) {
        // this.socket = io(`http://${location.hostname}:8082`, {
        this.socket = io('https://live.mindsidiomas.com.br:2020', {
          path: '/socket/classroom',
          transports: ['websocket'],
          secure: true,
          rejectUnauthorized: false
        })

        this.connectionTimeout = setTimeout(() => {
          this.creating = false
          alert('Failed to connect to server')
          this.closeClassroom()
        }, 1000 * 5)

        this.socket.on('connect', () => {
          if (this.connectionTimeout) {
            clearTimeout(this.connectionTimeout)
            this.connectionTimeout = null
          }

          if (this.socketKeepAlive)
            clearInterval(this.socketKeepAlive)

          this.socketKeepAlive = setInterval(() => {
            this.socket.emit('keep_alive')
          }, 5000)

          if (!reconnect) {
            this.socket.emit('open_classroom', { school: this.teacher.school, classroom_id: this.currentRoom })

            this.socket.on('classroom_opened', async () => {
              try {
                this.classroomKey = await this.$store.dispatch('teacher/useClassroom', this.currentRoom)
              } catch (error) {
                alert(error.message || 'Failed to Create Room')
                this.closeClassroom()
              } finally {
                this.creating = false
              }
            })

            this.socket.on('classroom_failed', async error => {
              this.creating = false
              alert(error.message || 'Failed to Create Room')
              this.closeClassroom()
            })
          } else {
            this.socket.emit('reconnect_classroom', { school: this.teacher.school, classroom_id: this.currentRoom, teacher_id: this.teacher._id })

            this.socket.on('classroom_reconnected', async ({ students, chat }) => {
              try {
                this.chat = chat || []

                for (const student of students) {
                  student.connection = this.createStudentConnection(student._id)

                  this.students.push(student)

                  this.$nextTick(() => {
                    this.makeOffer(student)
                  })
                }
              } catch (error) {
                alert(error.message || 'Failed to Create Room')
                this.closeClassroom()
              } finally {
                this.creating = false
              }
            })

            this.socket.on('reconnect_failed', async error => {
              this.creating = false
              alert(error.message || 'Failed to reconnect')
              this.closeClassroom()
            })
          }

          this.socket.on('connect_to_student', student => {
            const index = this.students.findIndex(s => s._id == student._id)

            if (index > -1) {
              const current = this.students[index]

              if (current.connection && current.connection.connectionState != 'closed')
                current.connection.close()

              student.connection = this.createStudentConnection(student._id)

              this.$set(this.students, index, student)

              this.$nextTick(() => {
                this.makeOffer(student)
              })
            } else {
              student.connection = this.createStudentConnection(student._id)

              this.students.push(student)

              this.$nextTick(() => {
                this.makeOffer(student)
              })
            }

            const studentsList = this.students
                                        .filter(s => (s._id != student._id && s.active))
                                        .map(s => JSON.parse(JSON.stringify(s)))
                                        .map(s => {
                                          this.$delete(s, 'connection')

                                          return s
                                        })

            this.socket.emit('student_joined', {
              students: studentsList,
              student_obj: student
            })
          })

          this.socket.on('answer_made_by_student', async ({ student_id, answer }) => {
            try {
              const student = this.students.find(s => s._id == student_id)

              if (student) {
                await student.connection.setRemoteDescription(new SessionDescription(answer))
                this.socket.emit('request_offer_by_teacher', student.socket)
              }
            } catch (error) {
              alert(error.message || 'Failed to make connection with the Student')
              console.warn(error)
            }
          })

          this.socket.on('offer_made_by_student', async ({ socket, offer, student_id }) => {
            try {
              const student = this.students.find(s => s._id == student_id)

              if (student) {
                await student.connection.setRemoteDescription(new SessionDescription(offer))

                const answer = await student.connection.createAnswer()

                await student.connection.setLocalDescription(new SessionDescription(answer))

                this.socket.emit('make_answer_by_teacher', {
                  answer: answer,
                  to: socket
                })
              }
            } catch (error) {
              console.log(error);
              alert(`Failed to Connect with Student!`)
            }
          })

          this.socket.on('message_sent', message => {
            this.chat.push(message)
          })

          this.socket.on('notification_sent', notification => {
            this.chat.push(notification)

            if (notification.notification_type == 'attention') {
              if (!this.$refs['alert-beep'].paused)
                this.$refs['alert-beep'].pause()

              this.$refs['alert-beep'].currentTime = 0

              this.$refs['alert-beep'].play()
            }
          })

          this.socket.on('failed_to_send_message', errorMessage => {
            alert(errorMessage)
          })

          this.socket.on('hand_raised', student_id => {
            const index = this.students.findIndex(s => s._id == student_id)
            this.$set(this.students[index], 'hand_raised', true)
          })

          this.socket.on('student_disconnected', student_id => {
            const index = this.students.findIndex(s => s._id == student_id)

            if (index > -1) {
              const student = this.students[index]

              if (student.connection && student.connection.connectionState != 'closed')
                student.connection.close()

              this.$set(this.students[index], 'active', false)

              const studentsList = this.students
                                          .filter(s => (s._id != student._id && s.active))
                                          .map(s => s.socket)

              this.socket.emit('student_left', {
                students: studentsList,
                student: {
                  _id: student._id,
                  name: student.name
                }
              })
            }
          })
        })
      },
      createStudentConnection (student_id) {
        const pc = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] })

        this.stream.getTracks().forEach(track => pc.addTrack(track, this.stream))

        pc.ontrack = async event => {
          const video = this.$refs[`student_video_${student_id}`][0]

          if (video)
            video.setStream(event.streams[0])
        }

        return pc
      },
      async makeOffer (student) {
        try {
          const offer = await student.connection.createOffer()

          await student.connection.setLocalDescription(new SessionDescription(offer))

          this.socket.emit('make_offer_by_teacher', {
            offer: offer,
            to: student.socket
          })
        } catch (error) {
          console.log(error);
          alert(`Failed to Connect with ${student.name}!`)
        }
      },
      async closeClassroom () {
        try {
          this.show = false
          this.socket.emit('close_classroom')

          if (this.stream) {
            const tracks = this.stream.getTracks()

            for (const track of tracks) {
              track.stop()
            }
          }

          if (this.currentRoom)
            this.currentRoom = null

          if (this.classroomKey)
            this.classroomKey = null

          if (this.socket) {
            this.socket.disconnect(true)
            this.socket = null
          }

          if (this.socketKeepAlive) {
            clearInterval(this.socketKeepAlive)
            this.socketKeepAlive = null
          }

          for (const student of this.students) {
            if (student.connection && student.connection.connectionState != 'closed')
              student.connection.close()
          }

          this.students = []
          this.chat = []
        } catch (error) {
          alert(error.message || 'Failed to close classroom')
        }
      },
      sendMessage (message) {
        if (message && this.socket && this.socket.connected) {
          this.socket.emit('send_message', {
            classroom: this.currentRoom,
            _id: this.teacher._id,
            name: `TEACHER ${this.teacher.name.split(' ').shift()}`,
            message: message,
            is_media: false
          })
          this.messageText = ''

          return true
        }
        return false
      },
      setMuted ({ student_id, muted }) {
        if (this.socket && this.socket.connected) {
          const index = this.students.findIndex(s => s._id == student_id)

          if (!muted && this.students[index].hand_raised)
            this.$set(this.students[index], 'hand_raised', false)

          if (this.students[index].has_media) {
            this.$set(this.students[index], 'muted', muted)

            this.socket.emit('set_muted', {
              students: this.students.filter(s => s._id != student_id).map(s => s.socket),
              classroom_id: this.currentRoom,
              student_socket: this.students[index].socket,
              student_id,
              muted
            })
          } else {
            this.socket.emit('give_attention', this.students[index].socket)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import './src/assets/css/base/variables';

.classrooms {
  flex: 1;
  display: flex;
  flex-direction: column;
  &__header {
    padding: 0 10px;
    &:not(:first-child) {
      padding: 5px 10px;
      margin-bottom: 10px;
    }
    &__heading {
      text-align: left;
      &--online {
        float: left;
        border: 2px solid #57BE29;
        border-radius: 15px;
        color: #57BE29;
        text-transform: uppercase;
        padding: 1px 35px;
      }
    }
  }
  &__box {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: stretch;
    border: 5px solid #ccc !important;
    border-radius: 15px;
    padding: 5px 10px;
    &__item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 5px 5px 10px 5px;
      margin: 5px 2px;
      border: 3px solid #BBB;
      border-radius: 5px;
      width: 210px;
      p.status {
        margin-top: 5px;
      }
      button.open-classroom {
        margin-top: 5px;
        border-radius: 15px;
      }
    }
  }
}

.modal-call {
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgba(25, 25, 25, 0.95);
  color: #fff;
  &.modal-call__animation--open {
    animation: open .8s ease-in;
  }
  &.modal-call__animation--close {
    animation: close .5s ease-out;
  }
  &__talking {
    &__box {
      height: calc(100% - 77px);
      max-height: calc(100% - 77px);
    }
    position: relative;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: center;
    overflow: hidden;
    z-index: 100;
    &__classroomkey {
      color: $color-red;
      font-size: 32px;
      margin: 20px auto;
    }
    &__streams {
      min-width: 350px;
      padding: 0 10px 10px 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      &__mine {
        display: flex;
        justify-content: center;
        height: auto;
        flex: 1;
        max-height: 60%;
        &__teacher {
          width: 100%;
          height: auto;
        }
      }
      &__others {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        max-height: 40%;
        overflow-y: auto;
      }
    }
    &__hangup {
      cursor: pointer;
      position: absolute;
      top: 7px;
      right: 20px;
      background-color: #C20030;
      color: #fff;
      padding: 15px 13px;
      border-radius: 150px;
      svg {
        font-size: 30px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .modal-call__talking {
    &__box {
      height: calc(100% - 35vh - 77px);
      max-height: calc(100% - 35vh - 77px);
    }
    &__streams__mine {
      height: calc(100% - 175px);
      max-height: calc(100% - 175px);
    }
    &__streams__others {
      height: 175px;
      flex-wrap: nowrap;
    }
  }
}

@keyframes open {
  0% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
  100% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
}

@keyframes close {
  0% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
  100% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
}

@keyframes calling {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes callingEntry {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/teacher/home.vue